import { render, staticRenderFns } from "./UploadTranscriptForm.vue?vue&type=template&id=3e87ef16&"
import script from "./UploadTranscriptForm.vue?vue&type=script&lang=js&"
export * from "./UploadTranscriptForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports